import { loadStripe, type Stripe } from "@stripe/stripe-js";

// Lazily load Stripe.js — the script is fetched from js.stripe.com on first
// CALL, not at module import. Calling loadStripe() at a module's top level
// meant Stripe.js loaded on app startup (on "/"), so every wrapped-app open
// hit js.stripe.com and failed for offline/restricted WebViews ("Failed to
// load Stripe.js") or threw on non-HTTPS app origins ("must use HTTPS"), even
// for users who never reached checkout. Components call getStripe() on mount
// so the fetch only happens when payment is actually needed. The package is
// still statically imported (no dynamic import() — see trap #12).
let stripePromise: Promise<Stripe | null> | null = null;

export function getStripe(): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY);
  }
  return stripePromise;
}
